import React from 'react';
import './App.css';
import Navbar from './components/Navbar/Navbar'
import Footer from './components/Footer/Footer';

function App() {
  return (
   <React.Fragment>
     <Navbar />
     <Footer />
   </React.Fragment>
  );
}

export default App;
